import { render, staticRenderFns } from "./edit-threshold-modal.vue?vue&type=template&id=7320c6c8"
import script from "./edit-threshold-modal.vue?vue&type=script&lang=ts"
export * from "./edit-threshold-modal.vue?vue&type=script&lang=ts"
import style0 from "./edit-threshold-modal.vue?vue&type=style&index=0&id=7320c6c8&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7320c6c8')) {
      api.createRecord('7320c6c8', component.options)
    } else {
      api.reload('7320c6c8', component.options)
    }
    module.hot.accept("./edit-threshold-modal.vue?vue&type=template&id=7320c6c8", function () {
      api.rerender('7320c6c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/thresholds-tab/edit-threshold-modal/edit-threshold-modal.vue"
export default component.exports